import {roomCoordiApi} from "@/core/api/room.coordi.api";
import {roomCoordiService} from "@/core/service/room.coordi.service";

export default {
    getUserStickerList: async ({dispatch, commit, getters, rootGetters}, {roomId, userId}) => {
        const response = await roomCoordiApi.getUserStickerList({roomId, userId});
        commit('SET_USER_STICKER_LIST', {stickerList: response?.data.stickerList, userId});
    },
    async getPurchaseStickerList(){
        return await roomCoordiApi.getPurchaseStickerList();
    },
    getStickerList: async ({commit, state}, data) => {
        if(state.stickers.length !== 0) {
            return;
        }
        const response = await roomCoordiApi.getStickerList(data);
        commit('SET_STICKER_LIST', response);
    },
    getStickerItem: async ({dispatch, commit, state}, itemId) => {
        if(state.stickerItems[itemId] && state.stickerItems[itemId].length !== 0) {
            return;
        }
        const response = await roomCoordiApi.getStickerItems(itemId)
        commit('SET_STICKER_ITEM', {itemId, data: response.data});
    },
    setUserSticker: async ({dispatch, commit, state}, data) => {
        await roomCoordiApi.setUserSticker(data)
    }
}